import { useState } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import Layout from '@/components/Layout';
import EmployeeModal from '@/components/EmployeeModal';
import HomePage from '@/pages/HomePage';
import TemplateManager from '@/pages/TemplateManager';
import CompanyManager from '@/pages/CompanyManager';
import ClauseManager from '@/pages/ClauseManager';
import ContractRecords from '@/pages/ContractRecords';
import ContractGenerator from '@/pages/ContractGenerator';
import RiskRuleManager from '@/pages/RiskRuleManager';
import PreviewPage from '@/pages/PreviewPage';

function App() {
  const [registered, setRegistered] = useState(false);

  return (
    <>
      <EmployeeModal onRegistered={() => setRegistered(true)} />
      {registered && (
        <Routes>
          <Route element={<Layout />}>
            <Route path="/" element={<HomePage />} />
            <Route path="/templates" element={<TemplateManager />} />
            <Route path="/companies" element={<CompanyManager />} />
            <Route path="/clauses" element={<ClauseManager />} />
            <Route path="/generate" element={<ContractGenerator />} />
            <Route path="/risk-rules" element={<RiskRuleManager />} />
            <Route path="/records" element={<ContractRecords />} />
            <Route path="/preview" element={<PreviewPage />} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Route>
        </Routes>
      )}
    </>
  );
}

export default App;
